export const sleep = (sec) => new Promise((resolve) => setTimeout(() => resolve(), sec * 1000));
export const timeAgo = (timestamp) => {
    const now = Date.now();
    const diffInSeconds = Math.floor((now - timestamp) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInMonths = Math.floor(diffInDays / 30);
    const diffInYears = Math.floor(diffInMonths / 12);
    if (diffInSeconds < 60) {
        return diffInSeconds <= 1 ? 'just now' : `${diffInSeconds} seconds ago`;
    }
    else if (diffInMinutes < 60) {
        return diffInMinutes <= 1 ? '1 minute ago' : `${diffInMinutes} minutes ago`;
    }
    else if (diffInHours < 24) {
        return diffInHours <= 1 ? '1 hour ago' : `${diffInHours} hours ago`;
    }
    else if (diffInDays < 30) {
        return diffInDays <= 1 ? 'yesterday' : `${diffInDays} days ago`;
    }
    else if (diffInMonths < 12) {
        return diffInMonths <= 1 ? '1 month ago' : `${diffInMonths} months ago`;
    }
    else {
        return diffInYears <= 1 ? '1 year ago' : `${diffInYears} years ago`;
    }
};
